export const identifiers: { [key: string]: string } = {
    access_token: 'accessToken',
    refresh_token: 'refreshToken',
    preview: 'previewLink',
    translation: 'translation',
    languages: 'languages',
    privilegeList: 'privilege_list',
    date_format: 'DD/MM/YYYY',
    date_input: 'YYYY-MM-DD',
    month_input: 'MMM-YYYY',
    field_error: 'This Field is Required',
    filters: 'filters',
    selectedLanguage: 'selectedLanguage',
    theme: 'theme',
    logo: 'https://uploads-ssl.webflow.com/5e46403ef1271f0d2212e4d5/5e468b39fcbf69f9b697bfea_192-150x150.png',
    REACT_APP_GOOGLE_RECAPTCHA: '6Lf4PIUtAAAAAHW0R45MOKUrniapOIN6wqPvL6tG',
    currency: 'currency',
    organization: 'organization',
    integration: 'integration',
    CONTRACT: 'CONTRACT_TEMPLATE',
    PROPOSAL: 'PROPOSAL_TEMPLATE',
    PI: 'PI_TEMPLATE',
    ENQUIRY: 'ENQUIRY_TEMPLATE',
    REACT_APP_CLIENT: 'bbradmin',
    REACT_APP_SECRET: 'bbr#234',
    isSalesManagementEnabled: 'isSalesManagementEnabled',
    isCaptureLoyaltyProgram: 'isCaptureLoyaltyProgram',
};
